import { LevelType } from 'data/types';
import { levelHasDeclinedHeatingAndCooling } from 'utils/structure';
import { sortLevelsByVerticalPosition } from 'utils/structure-basics';

export function getLevelDetailLevels(structure: LevelType[]): LevelType[] {
  return sortLevelsByVerticalPosition(structure);
}

export function getLayoutImageLevels(structure: LevelType[]): LevelType[] {
  return sortLevelsByVerticalPosition(structure)
    .toReversed()
    .filter((level) => !levelHasDeclinedHeatingAndCooling(level));
}

export function getPagerLevelsForStep(
  structure: LevelType[],
  stepId: string
): LevelType[] {
  if (stepId === 'layout_images') {
    return getLayoutImageLevels(structure);
  }
  return getLevelDetailLevels(structure);
}
